import { Link } from 'react-router-dom';
import { Dropdown, Label, Menu, SemanticCOLORS } from 'semantic-ui-react';

import { TeamStats } from '../MainHeader.types';

interface TeamPendingStatsProps {
  teamStats: TeamStats[];
  totalPending: number;
  colors: SemanticCOLORS[];
}

const TeamPendingStats = ({
  teamStats,
  totalPending,
  colors,
}: TeamPendingStatsProps) => {
  return teamStats && totalPending >= 0 ? (
    <Menu.Item>
      <Dropdown
        simple
        icon={
          <Label circular color='blue'>
            {totalPending}
          </Label>
        }
      >
        <Dropdown.Menu>
          {teamStats.map((team, index) => (
            <Dropdown.Item
              key={`${index}-${team.xpas_team_id}`}
              as={Link}
              to={`/queue/teams/${team.xpas_team_id}`}
            >
              <Label circular color={colors[index]}>
                {team.pending}
              </Label>
              {team.xpas_team_name}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </Menu.Item>
  ) : null;
};

export default TeamPendingStats;
